import { render, staticRenderFns } from "./company-add-or-update.vue?vue&type=template&id=a148522a&"
import script from "./company-add-or-update.vue?vue&type=script&lang=js&"
export * from "./company-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports